
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3BDe4", function(module, exports) {
$parcel$export(module.exports, "default", () => $897e49c563368051$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $e6n00 = parcelRequire("e6n00");

parcelRequire("42omo");

function $897e49c563368051$export$2e2bcd8739ae039(props) {
    const { children: children, localId: localId, resourceId: resourceId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-bodied-sync-block": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $e6n00.BodiedSyncBlockSharedCssClassName).renderer,
        "data-local-id": localId,
        "data-resource-id": resourceId,
        children: children
    });
}

});


//# sourceMappingURL=bodiedSyncBlock.00a93a93.js.map
